import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3814c311"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "checkout" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/",
  id: "back"
}, "« Add more tickets", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Checkout", -1))
const _hoisted_4 = { id: "checkout-container" }
const _hoisted_5 = { id: "billing-details" }
const _hoisted_6 = { id: "customer-info-form" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Billing Information", -1))
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-control" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "firstName" }, "First Name", -1))
const _hoisted_11 = { class: "form-control" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lastName" }, "Last Name", -1))
const _hoisted_13 = { class: "form-control" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_15 = { class: "form-control" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "phone", -1))
const _hoisted_17 = { class: "form-control" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "line1" }, "Address", -1))
const _hoisted_19 = { class: "form-control" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "line2" }, "Address Line 2", -1))
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "form-control city" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "city" }, "City", -1))
const _hoisted_24 = { class: "form-control state" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "state" }, "State", -1))
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<option value=\"AL\" data-v-3814c311>Alabama</option><option value=\"AK\" data-v-3814c311>Alaska</option><option value=\"AZ\" data-v-3814c311>Arizona</option><option value=\"AR\" data-v-3814c311>Arkansas</option><option value=\"CA\" data-v-3814c311>California</option><option value=\"CO\" data-v-3814c311>Colorado</option><option value=\"CT\" data-v-3814c311>Connecticut</option><option value=\"DE\" data-v-3814c311>Delaware</option><option value=\"FL\" data-v-3814c311>Florida</option><option value=\"GA\" data-v-3814c311>Georgia</option><option value=\"HI\" data-v-3814c311>Hawaii</option><option value=\"ID\" data-v-3814c311>Idaho</option><option value=\"IL\" data-v-3814c311>Illinois</option><option value=\"IN\" data-v-3814c311>Indiana</option><option value=\"IA\" data-v-3814c311>Iowa</option><option value=\"KS\" data-v-3814c311>Kansas</option><option value=\"KY\" data-v-3814c311>Kentucky</option><option value=\"LA\" data-v-3814c311>Louisiana</option><option value=\"ME\" data-v-3814c311>Maine</option><option value=\"MD\" data-v-3814c311>Maryland</option><option value=\"MA\" data-v-3814c311>Massachusetts</option><option value=\"MI\" data-v-3814c311>Michigan</option><option value=\"MN\" data-v-3814c311>Minnesota</option><option value=\"MS\" data-v-3814c311>Mississippi</option><option value=\"MO\" data-v-3814c311>Missouri</option><option value=\"MT\" data-v-3814c311>Montana</option><option value=\"NE\" data-v-3814c311>Nebraska</option><option value=\"NV\" data-v-3814c311>Nevada</option><option value=\"NH\" data-v-3814c311>New Hampshire</option><option value=\"NJ\" data-v-3814c311>New Jersey</option><option value=\"NM\" data-v-3814c311>New Mexico</option><option value=\"NY\" data-v-3814c311>New York</option><option value=\"NC\" data-v-3814c311>North Carolina</option><option value=\"ND\" data-v-3814c311>North Dakota</option><option value=\"OH\" data-v-3814c311>Ohio</option><option value=\"OK\" data-v-3814c311>Oklahoma</option><option value=\"OR\" data-v-3814c311>Oregon</option><option value=\"PA\" data-v-3814c311>Pennsylvania</option><option value=\"RI\" data-v-3814c311>Rhode Island</option><option value=\"SC\" data-v-3814c311>South Carolina</option><option value=\"SD\" data-v-3814c311>South Dakota</option><option value=\"TN\" data-v-3814c311>Tennessee</option><option value=\"TX\" data-v-3814c311>Texas</option><option value=\"UT\" data-v-3814c311>Utah</option><option value=\"VT\" data-v-3814c311>Vermont</option><option value=\"VA\" data-v-3814c311>Virginia</option><option value=\"WA\" data-v-3814c311>Washington</option><option value=\"WV\" data-v-3814c311>West Virginia</option><option value=\"WI\" data-v-3814c311>Wisconsin</option><option value=\"WY\" data-v-3814c311>Wyoming</option>", 50)
const _hoisted_76 = [
  _hoisted_26
]
const _hoisted_77 = { class: "form-control zip-code" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "postal_code" }, "Zip Code", -1))
const _hoisted_79 = { id: "card-container" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Credit Card Information", -1))
const _hoisted_81 = {
  key: 0,
  class: "error"
}
const _hoisted_82 = { id: "stripe-card-element" }
const _hoisted_83 = {
  key: 0,
  type: "submit"
}
const _hoisted_84 = { id: "cart-container" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Cart Summary", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SiteHeader = _resolveComponent("SiteHeader")!
  const _component_StripeElement = _resolveComponent("StripeElement")!
  const _component_SpinnerElement = _resolveComponent("SpinnerElement")!
  const _component_CartSummary = _resolveComponent("CartSummary")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SiteHeader),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", {
            onSubmit: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.checkout && _ctx.checkout(...args)))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "firstName",
                    required: "true",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstName) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.firstName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "lastName",
                    required: "true",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.lastName]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "email",
                  required: "true",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "phone",
                  required: "true",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.phone) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.phone]
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "line1",
                  required: "true",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.line1) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.line1]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "line2",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.line2) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.line2]
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "city",
                    required: "true",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.city) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.city]
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _withDirectives(_createElementVNode("select", {
                    name: "state",
                    required: "true",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state) = $event))
                  }, _hoisted_76, 512), [
                    [_vModelSelect, _ctx.state]
                  ])
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _hoisted_78,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "postal_code",
                    required: "true",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.postalCode) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.postalCode]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_79, [
              _hoisted_80,
              (_ctx.checkoutError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(_ctx.checkoutError), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_82, [
                _createVNode(_component_StripeElement, {
                  element: _ctx.cardElement,
                  onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.event = $event))
                }, null, 8, ["element"])
              ])
            ]),
            (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("button", _hoisted_83, "Place Order"))
              : _createCommentVNode("", true),
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_SpinnerElement, {
                  key: 1,
                  text: "Sending Order",
                  class: "spinner"
                }))
              : _createCommentVNode("", true)
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_84, [
          _hoisted_85,
          _createVNode(_component_CartSummary, {
            onCart: _ctx.cartContents,
            onUpdateEvent: _ctx.cartUpdate
          }, null, 8, ["onCart", "onUpdateEvent"])
        ])
      ])
    ])
  ], 64))
}